// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/svg/x-circle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/svg/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/svg/error-toast.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/svg/success-toast.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/svg/warning-toast.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27rgba%2814,104,237,1%29%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27rgba%285,128,141,1%29%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Inter', sans-serif !important;
  font-style: normal !important;
  font-weight: 500 !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/*----------- Forms -----------*/

input[type='radio']:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: 1px;
  left: -1.2px;
  position: relative;
  background-color: white;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid var(--white-2);
}

input[type='radio']:checked:after {
  content: '';
  border-radius: 17px;
  width: 16px;
  height: 16px;
  background-color: #c4c4c4;
  display: inline-block;
  position: relative;
  border: 4px solid #0064f8;
  background-color: var(--white);
}

input[type='checkbox'] {
  accent-color: #52949b;
}

input[type='checkbox']:after {
  box-shadow: none !important;
}

.formInput {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);
  border-radius: 6px !important;
  height: 33px;
  font-size: 16.8px !important;
  font-weight: 300 !important;
  border: none !important;
  padding: 6px 12px !important;
}

.formInput::-webkit-input-placeholder {
  font-size: 0.9rem;
}

.invalid-input {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: red;
  font-weight: 100;
  height: 1px;
}

.valid-input {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--primary-green);
  font-weight: 100;
  height: 1px;
}

.formRadious input[type='radio'] {
  display: none;
}

.formRadious label span {
  border-radius: 17px;
  width: 16px;
  height: 16px;
  position: relative;
  border: 2px solid var(--white-2);
  background-color: var(--white);
  display: flex;
  flex-direction: row;
  margin-right: -2px;
}

.formRadious input[type='radio']:checked + span {
  border-radius: 17px;
  width: 16px;
  height: 16px;
  background-color: #c4c4c4;
  display: block;
  position: relative;
  border: 4px solid #0064f8;
  background-color: var(--white);
}

.form-control.is-invalid,
.was-validated .form-control:invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.formSelect {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);
  border-radius: 6px !important;
  height: 33px;
  font-weight: 300 !important;
  font-size: 0.9rem !important;
  color: #91979f !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: none !important;
  padding: 6px 12px !important;
}

.formTextBox {
  flex-wrap: nowrap;
  border-radius: 6px !important;
}

.formTextArea {
  height: 160px;
  display: flex;
  font-size: 16.8px !important;
  font-weight: 300 !important;
  flex-wrap: nowrap;
  border-color: var(--white-1) !important;
  border-radius: 6px !important;
}

.formTextArea::-webkit-input-placeholder {
  font-size: 0.9rem;
}

.var-checkbox label.formLabel,
.var-radio label.formLabel {
  text-align: left;
}

.formLabel {
  font-weight: 500;
  font-size: 16.16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  color: var(--form-label);
}
.makeStyles-selectedTab-1.MuiTab-root {
  font-size: 12px !important;
  min-width: 7rem !important;
  padding: 10px !important;
}
.makeStyles-unselectedTab-2.MuiTab-root {
  min-width: 7rem !important;
  font-size: 12px !important;
  padding: 10px !important;
}
.css-13xfq8m-MuiTabPanel-root {
  padding: 10px !important;
}

.formRadioLabel {
  font-size: 14px;
  font-weight: 300;
  margin-top: -3px;
  padding-right: 0;
  margin-right: 10px;
}

.radioLabelListastMult {
  font-size: 14px;
  font-weight: 300;
  margin-top: 5px;
  padding-right: 0;
  margin-right: 10px;
}

.formLabelOpcional {
  font-weight: 300;
  font-size: 14px;
  margin: 0 5px;
  padding: 0;
  letter-spacing: -0.01em;
  color: var(--form-label-grey);
}

.formContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 35px;
  margin-bottom: 10px;
}

.formAdd {
  width: 95%;
  height: 100%;
  margin-top: 15px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

@media only screen and (max-width: 1199px) {
  .formAdd {
    width: 75%;
  }
}

.formContainer2 {
  background-color: #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
}

.formContainerNoData {
  background-color: var(--white);
  border-radius: 5px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);
  padding: 110px;
}

.formTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 24.19px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--form-label);
}

.formSubTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: -0.01em;
  color: var(--form-label);
}

.formRadious {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.formRadious > div {
  display: flex;
}

.colorLabelContainer {
  position: relative;
}

.colorLabel {
  color: #6f81a5;
  padding: 0;
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  text-align: start;
  letter-spacing: -0.01em;
  position: absolute;
  top: 0.3rem;
  left: 15.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input[type='color'] {
  -webkit-appearance: none;
  border: none;
}
input[type='color']::-webkit-color-swatch-wrapper {
  padding: 0;
}
input[type='color']::-webkit-color-swatch {
  border: none;
  border-radius: 5px;
  max-width: 14rem;
}

.btnSaveContainer {
  color: var(--white-1);
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 0 1em;
}

.btnSave {
  width: 95%;
  height: 33px;
  top: 73px;
  border-radius: 6px;
  color: var(--white);
  background-color: var(--secundary-color) !important;
  border: none;
  margin-top: 2rem;
}

.btnSave:disabled {
  background-color: var(--secundary-color-disabled) !important;
}

.btnCancel {
  width: 95%;
  height: 33px;
  top: 73px;
  border-radius: 6px;
  color: var(--main-color);
  background-color: var(--white);
  border: none;
  margin-top: 2rem;
}

.btnGoBack {
  margin-top: 1em;
  margin-bottom: 5px;
  background-color: grey;
  color: var(--white-1);
  width: 6rem;
  height: 2rem;
  border-radius: 10px;
  border: none;
  display: inline-block;
  justify-content: center;
}

.filtrarBtn {
  border-radius: 0.4rem !important;
  width: 10rem;
  height: 2rem;
  border: none;
  color: rgb(253, 253, 253);
  background-color: var(--secundary-color);
}

.filtrarBtn:disabled {
  background-color: var(--secundary-color-disabled);
}

.filtrarBtn:hover:not([disabled]) {
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

.filtrarBtn2 {
  border-radius: 0.4rem !important;
  width: 10rem;
  height: 2rem;
  border: none;
  float: right;
  color: rgb(253, 253, 253);
  background-color: var(--secundary-color);
}

.filtrarBtn3 {
  border-radius: 0.4rem !important;
  width: 15rem;
  height: 2rem;
  border: none;
  float: right;
  color: rgb(253, 253, 253);
  background-color: var(--secundary-color);
}

.filtrarBtn2:hover,
.filtrarBtn3:hover {
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

.excelBtn {
  border-radius: 0.4rem !important;
  width: 5.38rem;
  height: 2rem;
  border: none;
  color: rgb(253, 253, 253);
  background-color: var(--form-btn-excel);
}

.excelBtn:hover {
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

.completeReportBtnExcel {
  border-radius: 0.4rem !important;
  width: 10rem;
  height: 2rem;
  border: none;
  color: rgb(253, 253, 253);
  background-color: var(--form-btn-excel);
}

.completeReportBtnExcel:hover {
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

.pillBtnLimpiar {
  border-radius: 0.4rem !important;
  width: 10rem;
  height: 2rem;
  border: none;
  color: var(--main-color);
  background-color: white;
}

.pillBtnLimpiar:hover {
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.btnFilter {
  color: #fff !important;
  background-color: #6c757d !important;
  border-color: #6c757d;
  min-width: 5rem;
}

::placeholder {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  letter-spacing: -0.01em;
}

.noDataTitle {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 20.16px;
  letter-spacing: -0.01em;
  color: var(--no-data-grey);
}

.noDataInfo {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 16.8px;
  letter-spacing: -0.01em;
  color: var(--no-data-grey);
}

/*----------- Filters -----------*/

.filterContainer {
  background-color: var(--filter-container);
  min-width: 100%;

  border-radius: 10px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
}

.triangle {
  margin-right: 25.3em;
  margin-top: 0.7em;
  width: 0;
  height: 0;
  border-left: 2em solid transparent;
  border-right: 2em solid transparent;
  border-bottom: 1.1em solid var(--filter-container);
}

.actionBtn {
  border: none;
  background-color: rgba(0, 0, 0, 0);
  list-style: none;
  color: var(--main-color);
  transition: transform 0.2s;
  width: 3rem !important;
  height: 2rem !important;
  font-size: 1.15rem;
  line-height: 1;
}

.actionBtn:disabled {
  color: grey;
}

.actionBtn:disabled svg path {
  stroke: grey;
}

.filterInput {
  width: 95% !important;
  background-color: #ffffff !important;
  border: none !important;
  height: 2.1rem !important;
  padding-left: 2.2rem !important;
  height: 32px !important;
  font-weight: 300 !important;
}

.filterInput:focus {
  outline: none;
  box-shadow: 0 0 4px #719ece !important;
}

.filterInput::-webkit-input-placeholder,
.selectInput::-webkit-input-placeholder {
  font-size: 0.9rem;
  margin-top: 2px;
}

.inputWrapper {
  position: relative;
}

.filterLabel {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  letter-spacing: -0.01em;
  color: #252525;
}

.actionBtn:enabled:hover {
  transform: scale(1.1);
}

.icon {
  position: absolute;
  margin-left: 10px;
  margin-top: 3px;
  color: #ebebeb;
  height: 0px !important;
}

.selectInput {
  color: #6f81a5 !important;
  font-style: normal;
  font-weight: 300 !important;
  font-size: 14px !important;
  text-align: start;
  letter-spacing: -0.01em;
  height: 2.1rem !important;
  cursor: pointer;
  border: none !important;
  padding-bottom: 5px !important;
}

.selectInput:hover {
  outline: none;
  border-color: #6f81a5;
  box-shadow: 0 0 10px #719ece;
}

/*------------------------------------------------*/
.accordion-button {
  background-color: #f5f5f5 !important;
}

.accordion-button:focus {
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  color: #252525 !important;
}
.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}

/*------------------------------------------------*/

:root {
  --bg-primary: rgb(41, 41, 51);
  --bg-primary-alpha: rgba(41, 41, 51, 0.5);
  --bg-primary-alpha2: rgba(41, 41, 51, 0.2);
  --primary: rgb(255, 116, 23);
  --primary-disabled: rgb(255, 168, 110);
  --primary-hover: rgb(211, 84, 0);
  --primary-alpha: rgba(170, 0, 0, 0.05);
  --primary-required: rgb(255, 216, 190);
  --no-data-grey: #565a5c;
  --tooltip-line: #c4c4c4;
  --white-1: #eee;
  --white-2: #ddd;
  --white: #ffffff;
  --grey: #c4c4c4;
  --main-color: #0064f8;
  --main-color-disabled: #60a0ff;
  --secundary-color: #ff5e62;
  --secundary-color-disabled: #ff918f;
  --form-label: #252525;
  --form-label-grey: #91979f;
  --form-btn-cancel: #6b7c82;
  --primary-green: #0064f8;
  --primary-green-dark: #0445a7;
  --primary-green-light: #c3d0d1;
  --primary-variant-color: #a9b7b8;
  --secondary-color: #ff5e62;
  --secondary-variant-color: #ff7c80;
  --form-btn-save: #ff5a5f;
  --form-btn-filter: #ff5e62;
  /* --form-btn-excel: #0064f8; */
  --form-btn-excel: #0064f8;
  --auth-grey: #565a5c;
  --auth-black: rgba(0, 0, 0, 0.04);
  --filter-container: #f5f5f5;
  --alert-cancel-btn: #f1f1f1;
  --black: #000000;
}

::-webkit-scrollbar {
  width: 9px;
  height: 7px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
}

::-webkit-scrollbar-thumb {
  background: var(--grey);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--primary-green);
}

/* ---------- SCROLLBAR MOZILLA FIREFOX ----------*/
.dashboard {
  scrollbar-color: var(--grey) var(--white);
  scrollbar-width: thin;
}
/* ------------------------------------------------*/

.list-group-item {
  background-color: var(--bg-primary) !important;
  color: var(--white-1) !important;
}

.list-group-item:hover {
  background-color: var(--primary-alpha) !important;
  color: var(--primary) !important;
}

.list-group-item-action {
  background-color: var(--bg-primary) !important;
  color: var(--primary) !important;
}

.list-group-item-action:hover {
  background-color: var(--primary-alpha) !important;
  color: var(--primary) !important;
}

/* .page-link {
	color: var(--white-1) !important;
	background-color: var(--bg-primary-alpha) !important;
}

.page-item.active .page-link {
	border-color: var(--primary) !important;
	background-color: var(--bg-primary) !important;
} */

/* ERROR TOAST */
.Toastify__toast--error {
  border-radius: 6px !important;
  background: #ffe4e3 !important;
}

.Toastify__toast--error div {
  color: #b03d40;
  font-family: 'Inter', sans-serif !important;
  font-weight: 500;
}

.Toastify__toast--error::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  position: relative;
  z-index: 100000;
  left: 5px;
  top: 14px;
}
.Toastify__progress-bar-theme--colored {
  height: 6px;
}
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: #b03d40 !important;
}

/* SUCCESS TOAST */
.Toastify__toast--success {
  border-radius: 6px !important;
  background: #d9f6d8 !important;
}

.Toastify__toast--success::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  position: relative;
  z-index: 100000;
  left: 5px;
  top: 14px;
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
  background: #1d9229 !important;
}

.Toastify__toast--success div {
  color: #1d9229;
  font-family: 'Inter', sans-serif !important;
  font-weight: 500;
}

/* WARNING TOAST */
.Toastify__toast--warning {
  border-radius: 6px !important;
  background: #fbf5dd !important;
}

.Toastify__toast--warning::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  position: relative;
  z-index: 100000;
  left: 5px;
  top: 14px;
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
  background: #d6b03e !important;
}

.Toastify__toast--warning div {
  color: #d6b03e;
  font-family: 'Inter', sans-serif !important;
  font-weight: 500;
}

.Toastify__toast-body {
  color: #444c63;
  font-size: 14px;
  padding-left: 20px;
  line-height: 17px;
  padding: 0px;
  width: 100%;
  font-weight: 500;
  margin-left: 14px !important;
  font-family: 'Inter', sans-serif !important;
}

.Toastify__toast-icon {
  display: none !important;
}
.Toastify__toast > button > svg {
  display: none;
}

.Toastify__toast-container {
  width: 445px !important;
  height: 64px !important;
  border-radius: 10px !important;
}

.react-confirm-alert-overlay {
  z-index: 9999 !important;
  background: #252525f7 !important;
}

.__react_component_tooltip::after {
  border-top-color: var(--white) !important;
}

.ql-editor.ql-blank {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  min-height: 300px;
  background-color: white;
  border-radius: 6px !important;
  border: none;
}

.ql-editor {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  min-height: 300px;
  background-color: white;
  border-radius: 6px !important;
  border: none;
}

.ql-toolbar.ql-snow {
  border-radius: 6px !important;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
  border: none !important;
  margin-bottom: 10px;
  background-color: white;
}
.ql-container.ql-snow {
  border-radius: 6px solid var(--white-1) !important;
  border-color: white;
  border: 1px solid white !important;
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-radius: 6px !important;
}

.ql-tooltip.ql-editing {
  left: 0 !important;
}

.ql-tooltip {
  left: 0 !important;
}

/* Add process styles */

.form-switch .form-check-input:focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: var(--grey);
  background-color: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
}

.form-switch .form-check-input:checked {
  box-shadow: none !important;
  outline: none !important;
  background-color: var(--white) !important;
  border-color: var(--primary-green) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) !important;
}

.form-check-input:checked {
  background-color: var(--white) !important;
}

.form-check-input.is-valid {
  box-shadow: none !important;
  background-position: right center !important;
  outline: none !important;
  background-color: var(--white) !important;
  border-color: var(--primary-green) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
}

.btnValidate {
  position: relative;
  border-radius: 6px;
  background-color: var(--primary-green);
  color: var(--white);
  border-color: var(--primary-green);
  border: none;
  width: 95%;
  height: 33px;
  top: -5px;
}

.btnInfo {
  background-color: var(--white-1);
  color: blue;
  border-color: blue;
  border-radius: 500px;
  display: block;
  width: 15%;
  height: 92%;
}

.btnSaveDisabled {
  background-color: var(--secundary-color-disabled) !important;
}

.subtitle {
  font-size: 13px;
  color: grey;
}

/*  Modal Body and Head background styles */
.modal-header {
  background: #eee;
}
.modal-body {
  background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1)) !important;
}

/*SunEditor*/
.sun-editor {
  font-family: 'Inter', sans-serif !important;
  border: none !important;
  border-radius: 1em !important;
}
.se-toolbar {
  border-radius: 0.375rem !important;
}

.se-btn {
  width: 30px !important;
  margin: 20px !important;
  /* background-color: var(--white) !important; */
}
.se-btn-select,
.se-btn-tool-font {
  width: 100px !important;
}
.se-btn-module-border {
  border: none !important;
  border-radius: 0% !important;
  margin: 0.5em;
  /* border-right: 0.2px solid #919191 !important; */
}

.sun-editor button {
  color: #3d3d3d !important;
}

.se-toolbar {
  background-color: var(--white) !important;
  outline: none !important;
}
.sun-editor .se-btn:enabled.active {
  color: var(--bs-primary) !important;
}

.se-wrapper-inner {
  margin: 1em;
}

.se-resizing-bar {
  background-color: var(--white) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}
.se-toolbar-separator-vertical {
  margin: 0.3em !important;
}

/* table */
.sun-editor-editable td,
.sun-editor-editable th {
  border: 1px solid #32383e !important;
}

.sun-editor-editable td:hover,
.sun-editor-editable th:hover {
  background-color: #ececec !important;
}

/* ----------------- VARIABLE CLASSES ----------------- */

.small {
  width: 250px !important;
}

.medium {
  width: 300px !important;
}

.large {
  width: 350px !important;
}

.x-large {
  width: 400px !important;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

/* ----------------- Width CLASSES ----------------- */
.w-95 {
  width: 95% !important;
}

.w-fit-content {
  width: fit-content !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;EAClC,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,+EAA+E;AACjF;;AAEA,gCAAgC;;AAEhC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,oCAAoC;EACpC,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;EAChE,oEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,6BAA6B;EAC7B,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;EAC3B,iBAAiB;EACjB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB;gCAC8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,kCAAkC;;AAElC;EACE,yCAAyC;EACzC,eAAe;;EAEf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,mDAAmD;AACnD;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oEAAsE;AACxE;;AAEA,mDAAmD;;AAEnD;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,0CAA0C;EAC1C,4BAA4B;EAC5B,sCAAsC;EACtC,gCAAgC;EAChC,sCAAsC;EACtC,sCAAsC;EACtC,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,0BAA0B;EAC1B,mCAAmC;EACnC,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,oBAAoB;EACpB,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,yCAAyC;EACzC,qBAAqB;AACvB;AACA,oDAAoD;;AAEpD;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;;;;;;;;GAQG;;AAEH,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gDAAiD;EACjD,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gDAAmD;EACnD,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gDAAmD;EACnD,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,+DAA+D;EAC/D,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kDAAkD;EAClD,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;;AAEvB;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,oEAAmL;AACrL;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,yCAAyC;EACzC,6CAA6C;EAC7C,oEAAkK;AACpK;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,wBAAwB;EACxB,yCAAyC;EACzC,6CAA6C;EAC7C,oEAAiK;AACnK;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;AACA;EACE,0FAA0F;AAC5F;;AAEA,YAAY;AACZ;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+CAA+C;AACjD;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;;AAEA,UAAU;AACV;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA,yDAAyD;;AAEzD;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;;AAEA;EAGE,6BAA6B;AAC/B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;500&display=swap');\r\n\r\nbody {\r\n  margin: 0;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-style: normal !important;\r\n  font-weight: 500 !important;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n\r\n/*----------- Forms -----------*/\r\n\r\ninput[type='radio']:after {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 15px;\r\n  top: 1px;\r\n  left: -1.2px;\r\n  position: relative;\r\n  background-color: white;\r\n  content: '';\r\n  display: inline-block;\r\n  visibility: visible;\r\n  border: 2px solid var(--white-2);\r\n}\r\n\r\ninput[type='radio']:checked:after {\r\n  content: '';\r\n  border-radius: 17px;\r\n  width: 16px;\r\n  height: 16px;\r\n  background-color: #c4c4c4;\r\n  display: inline-block;\r\n  position: relative;\r\n  border: 4px solid #0064f8;\r\n  background-color: var(--white);\r\n}\r\n\r\ninput[type='checkbox'] {\r\n  accent-color: #52949b;\r\n}\r\n\r\ninput[type='checkbox']:after {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.formInput {\r\n  background: #ffffff;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);\r\n  border-radius: 6px !important;\r\n  height: 33px;\r\n  font-size: 16.8px !important;\r\n  font-weight: 300 !important;\r\n  border: none !important;\r\n  padding: 6px 12px !important;\r\n}\r\n\r\n.formInput::-webkit-input-placeholder {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.invalid-input {\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 0.875em;\r\n  color: red;\r\n  font-weight: 100;\r\n  height: 1px;\r\n}\r\n\r\n.valid-input {\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 0.875em;\r\n  color: var(--primary-green);\r\n  font-weight: 100;\r\n  height: 1px;\r\n}\r\n\r\n.formRadious input[type='radio'] {\r\n  display: none;\r\n}\r\n\r\n.formRadious label span {\r\n  border-radius: 17px;\r\n  width: 16px;\r\n  height: 16px;\r\n  position: relative;\r\n  border: 2px solid var(--white-2);\r\n  background-color: var(--white);\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-right: -2px;\r\n}\r\n\r\n.formRadious input[type='radio']:checked + span {\r\n  border-radius: 17px;\r\n  width: 16px;\r\n  height: 16px;\r\n  background-color: #c4c4c4;\r\n  display: block;\r\n  position: relative;\r\n  border: 4px solid #0064f8;\r\n  background-color: var(--white);\r\n}\r\n\r\n.form-control.is-invalid,\r\n.was-validated .form-control:invalid {\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-repeat: no-repeat;\r\n  background-position: right calc(0.375em + 0.1875rem) center;\r\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n  background-image: url('../src/assets/svg/x-circle.svg') !important;\r\n}\r\n\r\n.formSelect {\r\n  background: #ffffff;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04);\r\n  border-radius: 6px !important;\r\n  height: 33px;\r\n  font-weight: 300 !important;\r\n  font-size: 0.9rem !important;\r\n  color: #91979f !important;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: right 0.75rem center;\r\n  background-size: 16px 12px;\r\n  border: none !important;\r\n  padding: 6px 12px !important;\r\n}\r\n\r\n.formTextBox {\r\n  flex-wrap: nowrap;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.formTextArea {\r\n  height: 160px;\r\n  display: flex;\r\n  font-size: 16.8px !important;\r\n  font-weight: 300 !important;\r\n  flex-wrap: nowrap;\r\n  border-color: var(--white-1) !important;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.formTextArea::-webkit-input-placeholder {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.var-checkbox label.formLabel,\r\n.var-radio label.formLabel {\r\n  text-align: left;\r\n}\r\n\r\n.formLabel {\r\n  font-weight: 500;\r\n  font-size: 16.16px;\r\n  line-height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: -0.01em;\r\n  color: var(--form-label);\r\n}\r\n.makeStyles-selectedTab-1.MuiTab-root {\r\n  font-size: 12px !important;\r\n  min-width: 7rem !important;\r\n  padding: 10px !important;\r\n}\r\n.makeStyles-unselectedTab-2.MuiTab-root {\r\n  min-width: 7rem !important;\r\n  font-size: 12px !important;\r\n  padding: 10px !important;\r\n}\r\n.css-13xfq8m-MuiTabPanel-root {\r\n  padding: 10px !important;\r\n}\r\n\r\n.formRadioLabel {\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  margin-top: -3px;\r\n  padding-right: 0;\r\n  margin-right: 10px;\r\n}\r\n\r\n.radioLabelListastMult {\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  margin-top: 5px;\r\n  padding-right: 0;\r\n  margin-right: 10px;\r\n}\r\n\r\n.formLabelOpcional {\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  margin: 0 5px;\r\n  padding: 0;\r\n  letter-spacing: -0.01em;\r\n  color: var(--form-label-grey);\r\n}\r\n\r\n.formContainer {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 35px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.formAdd {\r\n  width: 95%;\r\n  height: 100%;\r\n  margin-top: 15px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n}\r\n\r\n@media only screen and (max-width: 1199px) {\r\n  .formAdd {\r\n    width: 75%;\r\n  }\r\n}\r\n\r\n.formContainer2 {\r\n  background-color: #f1f1f1;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.formContainerNoData {\r\n  background-color: var(--white);\r\n  border-radius: 5px;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.06);\r\n  padding: 110px;\r\n}\r\n\r\n.formTitle {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 24.19px;\r\n  line-height: 29px;\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n  letter-spacing: -0.01em;\r\n  color: var(--form-label);\r\n}\r\n\r\n.formSubTitle {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 29px;\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: center;\r\n  letter-spacing: -0.01em;\r\n  color: var(--form-label);\r\n}\r\n\r\n.formRadious {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.formRadious > div {\r\n  display: flex;\r\n}\r\n\r\n.colorLabelContainer {\r\n  position: relative;\r\n}\r\n\r\n.colorLabel {\r\n  color: #6f81a5;\r\n  padding: 0;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 14px;\r\n  text-align: start;\r\n  letter-spacing: -0.01em;\r\n  position: absolute;\r\n  top: 0.3rem;\r\n  left: 15.5rem;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\ninput[type='color'] {\r\n  -webkit-appearance: none;\r\n  border: none;\r\n}\r\ninput[type='color']::-webkit-color-swatch-wrapper {\r\n  padding: 0;\r\n}\r\ninput[type='color']::-webkit-color-swatch {\r\n  border: none;\r\n  border-radius: 5px;\r\n  max-width: 14rem;\r\n}\r\n\r\n.btnSaveContainer {\r\n  color: var(--white-1);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-content: center;\r\n  padding: 0 1em;\r\n}\r\n\r\n.btnSave {\r\n  width: 95%;\r\n  height: 33px;\r\n  top: 73px;\r\n  border-radius: 6px;\r\n  color: var(--white);\r\n  background-color: var(--secundary-color) !important;\r\n  border: none;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.btnSave:disabled {\r\n  background-color: var(--secundary-color-disabled) !important;\r\n}\r\n\r\n.btnCancel {\r\n  width: 95%;\r\n  height: 33px;\r\n  top: 73px;\r\n  border-radius: 6px;\r\n  color: var(--main-color);\r\n  background-color: var(--white);\r\n  border: none;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.btnGoBack {\r\n  margin-top: 1em;\r\n  margin-bottom: 5px;\r\n  background-color: grey;\r\n  color: var(--white-1);\r\n  width: 6rem;\r\n  height: 2rem;\r\n  border-radius: 10px;\r\n  border: none;\r\n  display: inline-block;\r\n  justify-content: center;\r\n}\r\n\r\n.filtrarBtn {\r\n  border-radius: 0.4rem !important;\r\n  width: 10rem;\r\n  height: 2rem;\r\n  border: none;\r\n  color: rgb(253, 253, 253);\r\n  background-color: var(--secundary-color);\r\n}\r\n\r\n.filtrarBtn:disabled {\r\n  background-color: var(--secundary-color-disabled);\r\n}\r\n\r\n.filtrarBtn:hover:not([disabled]) {\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n.filtrarBtn2 {\r\n  border-radius: 0.4rem !important;\r\n  width: 10rem;\r\n  height: 2rem;\r\n  border: none;\r\n  float: right;\r\n  color: rgb(253, 253, 253);\r\n  background-color: var(--secundary-color);\r\n}\r\n\r\n.filtrarBtn3 {\r\n  border-radius: 0.4rem !important;\r\n  width: 15rem;\r\n  height: 2rem;\r\n  border: none;\r\n  float: right;\r\n  color: rgb(253, 253, 253);\r\n  background-color: var(--secundary-color);\r\n}\r\n\r\n.filtrarBtn2:hover,\r\n.filtrarBtn3:hover {\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n.excelBtn {\r\n  border-radius: 0.4rem !important;\r\n  width: 5.38rem;\r\n  height: 2rem;\r\n  border: none;\r\n  color: rgb(253, 253, 253);\r\n  background-color: var(--form-btn-excel);\r\n}\r\n\r\n.excelBtn:hover {\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n.completeReportBtnExcel {\r\n  border-radius: 0.4rem !important;\r\n  width: 10rem;\r\n  height: 2rem;\r\n  border: none;\r\n  color: rgb(253, 253, 253);\r\n  background-color: var(--form-btn-excel);\r\n}\r\n\r\n.completeReportBtnExcel:hover {\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n.pillBtnLimpiar {\r\n  border-radius: 0.4rem !important;\r\n  width: 10rem;\r\n  height: 2rem;\r\n  border: none;\r\n  color: var(--main-color);\r\n  background-color: white;\r\n}\r\n\r\n.pillBtnLimpiar:hover {\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  border: 1px solid transparent;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  border-radius: 0.25rem;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\r\n    box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.btnFilter {\r\n  color: #fff !important;\r\n  background-color: #6c757d !important;\r\n  border-color: #6c757d;\r\n  min-width: 5rem;\r\n}\r\n\r\n::placeholder {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 15px;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.noDataTitle {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 20.16px;\r\n  letter-spacing: -0.01em;\r\n  color: var(--no-data-grey);\r\n}\r\n\r\n.noDataInfo {\r\n  font-family: Inter;\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 16.8px;\r\n  letter-spacing: -0.01em;\r\n  color: var(--no-data-grey);\r\n}\r\n\r\n/*----------- Filters -----------*/\r\n\r\n.filterContainer {\r\n  background-color: var(--filter-container);\r\n  min-width: 100%;\r\n\r\n  border-radius: 10px;\r\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.triangle {\r\n  margin-right: 25.3em;\r\n  margin-top: 0.7em;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 2em solid transparent;\r\n  border-right: 2em solid transparent;\r\n  border-bottom: 1.1em solid var(--filter-container);\r\n}\r\n\r\n.actionBtn {\r\n  border: none;\r\n  background-color: rgba(0, 0, 0, 0);\r\n  list-style: none;\r\n  color: var(--main-color);\r\n  transition: transform 0.2s;\r\n  width: 3rem !important;\r\n  height: 2rem !important;\r\n  font-size: 1.15rem;\r\n  line-height: 1;\r\n}\r\n\r\n.actionBtn:disabled {\r\n  color: grey;\r\n}\r\n\r\n.actionBtn:disabled svg path {\r\n  stroke: grey;\r\n}\r\n\r\n.filterInput {\r\n  width: 95% !important;\r\n  background-color: #ffffff !important;\r\n  border: none !important;\r\n  height: 2.1rem !important;\r\n  padding-left: 2.2rem !important;\r\n  height: 32px !important;\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.filterInput:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 4px #719ece !important;\r\n}\r\n\r\n.filterInput::-webkit-input-placeholder,\r\n.selectInput::-webkit-input-placeholder {\r\n  font-size: 0.9rem;\r\n  margin-top: 2px;\r\n}\r\n\r\n.inputWrapper {\r\n  position: relative;\r\n}\r\n\r\n.filterLabel {\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  display: flex;\r\n  letter-spacing: -0.01em;\r\n  color: #252525;\r\n}\r\n\r\n.actionBtn:enabled:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.icon {\r\n  position: absolute;\r\n  margin-left: 10px;\r\n  margin-top: 3px;\r\n  color: #ebebeb;\r\n  height: 0px !important;\r\n}\r\n\r\n.selectInput {\r\n  color: #6f81a5 !important;\r\n  font-style: normal;\r\n  font-weight: 300 !important;\r\n  font-size: 14px !important;\r\n  text-align: start;\r\n  letter-spacing: -0.01em;\r\n  height: 2.1rem !important;\r\n  cursor: pointer;\r\n  border: none !important;\r\n  padding-bottom: 5px !important;\r\n}\r\n\r\n.selectInput:hover {\r\n  outline: none;\r\n  border-color: #6f81a5;\r\n  box-shadow: 0 0 10px #719ece;\r\n}\r\n\r\n/*------------------------------------------------*/\r\n.accordion-button {\r\n  background-color: #f5f5f5 !important;\r\n}\r\n\r\n.accordion-button:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n  color: #252525 !important;\r\n}\r\n.accordion-button:not(.collapsed)::after {\r\n  background-image: url('../src/assets/svg/chevron-down.svg') !important;\r\n}\r\n\r\n/*------------------------------------------------*/\r\n\r\n:root {\r\n  --bg-primary: rgb(41, 41, 51);\r\n  --bg-primary-alpha: rgba(41, 41, 51, 0.5);\r\n  --bg-primary-alpha2: rgba(41, 41, 51, 0.2);\r\n  --primary: rgb(255, 116, 23);\r\n  --primary-disabled: rgb(255, 168, 110);\r\n  --primary-hover: rgb(211, 84, 0);\r\n  --primary-alpha: rgba(170, 0, 0, 0.05);\r\n  --primary-required: rgb(255, 216, 190);\r\n  --no-data-grey: #565a5c;\r\n  --tooltip-line: #c4c4c4;\r\n  --white-1: #eee;\r\n  --white-2: #ddd;\r\n  --white: #ffffff;\r\n  --grey: #c4c4c4;\r\n  --main-color: #0064f8;\r\n  --main-color-disabled: #60a0ff;\r\n  --secundary-color: #ff5e62;\r\n  --secundary-color-disabled: #ff918f;\r\n  --form-label: #252525;\r\n  --form-label-grey: #91979f;\r\n  --form-btn-cancel: #6b7c82;\r\n  --primary-green: #0064f8;\r\n  --primary-green-dark: #0445a7;\r\n  --primary-green-light: #c3d0d1;\r\n  --primary-variant-color: #a9b7b8;\r\n  --secondary-color: #ff5e62;\r\n  --secondary-variant-color: #ff7c80;\r\n  --form-btn-save: #ff5a5f;\r\n  --form-btn-filter: #ff5e62;\r\n  /* --form-btn-excel: #0064f8; */\r\n  --form-btn-excel: #0064f8;\r\n  --auth-grey: #565a5c;\r\n  --auth-black: rgba(0, 0, 0, 0.04);\r\n  --filter-container: #f5f5f5;\r\n  --alert-cancel-btn: #f1f1f1;\r\n  --black: #000000;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 9px;\r\n  height: 7px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 5px grey;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--grey);\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--primary-green);\r\n}\r\n\r\n/* ---------- SCROLLBAR MOZILLA FIREFOX ----------*/\r\n.dashboard {\r\n  scrollbar-color: var(--grey) var(--white);\r\n  scrollbar-width: thin;\r\n}\r\n/* ------------------------------------------------*/\r\n\r\n.list-group-item {\r\n  background-color: var(--bg-primary) !important;\r\n  color: var(--white-1) !important;\r\n}\r\n\r\n.list-group-item:hover {\r\n  background-color: var(--primary-alpha) !important;\r\n  color: var(--primary) !important;\r\n}\r\n\r\n.list-group-item-action {\r\n  background-color: var(--bg-primary) !important;\r\n  color: var(--primary) !important;\r\n}\r\n\r\n.list-group-item-action:hover {\r\n  background-color: var(--primary-alpha) !important;\r\n  color: var(--primary) !important;\r\n}\r\n\r\n/* .page-link {\r\n\tcolor: var(--white-1) !important;\r\n\tbackground-color: var(--bg-primary-alpha) !important;\r\n}\r\n\r\n.page-item.active .page-link {\r\n\tborder-color: var(--primary) !important;\r\n\tbackground-color: var(--bg-primary) !important;\r\n} */\r\n\r\n/* ERROR TOAST */\r\n.Toastify__toast--error {\r\n  border-radius: 6px !important;\r\n  background: #ffe4e3 !important;\r\n}\r\n\r\n.Toastify__toast--error div {\r\n  color: #b03d40;\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-weight: 500;\r\n}\r\n\r\n.Toastify__toast--error::before {\r\n  content: url('../src/assets/svg/error-toast.svg');\r\n  position: relative;\r\n  z-index: 100000;\r\n  left: 5px;\r\n  top: 14px;\r\n}\r\n.Toastify__progress-bar-theme--colored {\r\n  height: 6px;\r\n}\r\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {\r\n  background: #b03d40 !important;\r\n}\r\n\r\n/* SUCCESS TOAST */\r\n.Toastify__toast--success {\r\n  border-radius: 6px !important;\r\n  background: #d9f6d8 !important;\r\n}\r\n\r\n.Toastify__toast--success::before {\r\n  content: url('../src/assets/svg/success-toast.svg');\r\n  position: relative;\r\n  z-index: 100000;\r\n  left: 5px;\r\n  top: 14px;\r\n}\r\n\r\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {\r\n  background: #1d9229 !important;\r\n}\r\n\r\n.Toastify__toast--success div {\r\n  color: #1d9229;\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-weight: 500;\r\n}\r\n\r\n/* WARNING TOAST */\r\n.Toastify__toast--warning {\r\n  border-radius: 6px !important;\r\n  background: #fbf5dd !important;\r\n}\r\n\r\n.Toastify__toast--warning::before {\r\n  content: url('../src/assets/svg/warning-toast.svg');\r\n  position: relative;\r\n  z-index: 100000;\r\n  left: 5px;\r\n  top: 14px;\r\n}\r\n\r\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {\r\n  background: #d6b03e !important;\r\n}\r\n\r\n.Toastify__toast--warning div {\r\n  color: #d6b03e;\r\n  font-family: 'Inter', sans-serif !important;\r\n  font-weight: 500;\r\n}\r\n\r\n.Toastify__toast-body {\r\n  color: #444c63;\r\n  font-size: 14px;\r\n  padding-left: 20px;\r\n  line-height: 17px;\r\n  padding: 0px;\r\n  width: 100%;\r\n  font-weight: 500;\r\n  margin-left: 14px !important;\r\n  font-family: 'Inter', sans-serif !important;\r\n}\r\n\r\n.Toastify__toast-icon {\r\n  display: none !important;\r\n}\r\n.Toastify__toast > button > svg {\r\n  display: none;\r\n}\r\n\r\n.Toastify__toast-container {\r\n  width: 445px !important;\r\n  height: 64px !important;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n.react-confirm-alert-overlay {\r\n  z-index: 9999 !important;\r\n  background: #252525f7 !important;\r\n}\r\n\r\n.__react_component_tooltip::after {\r\n  border-top-color: var(--white) !important;\r\n}\r\n\r\n.ql-editor.ql-blank {\r\n  color: rgba(0, 0, 0, 0.6);\r\n  content: attr(data-placeholder);\r\n  min-height: 300px;\r\n  background-color: white;\r\n  border-radius: 6px !important;\r\n  border: none;\r\n}\r\n\r\n.ql-editor {\r\n  color: rgba(0, 0, 0, 0.6);\r\n  content: attr(data-placeholder);\r\n  min-height: 300px;\r\n  background-color: white;\r\n  border-radius: 6px !important;\r\n  border: none;\r\n}\r\n\r\n.ql-toolbar.ql-snow {\r\n  border-radius: 6px !important;\r\n  box-sizing: border-box;\r\n  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\r\n  border: none !important;\r\n  margin-bottom: 10px;\r\n  background-color: white;\r\n}\r\n.ql-container.ql-snow {\r\n  border-radius: 6px solid var(--white-1) !important;\r\n  border-color: white;\r\n  border: 1px solid white !important;\r\n}\r\n.ql-toolbar.ql-snow + .ql-container.ql-snow {\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.ql-tooltip.ql-editing {\r\n  left: 0 !important;\r\n}\r\n\r\n.ql-tooltip {\r\n  left: 0 !important;\r\n}\r\n\r\n/* Add process styles */\r\n\r\n.form-switch .form-check-input:focus {\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n  border-color: var(--grey);\r\n  background-color: none !important;\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\") !important;\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n  background-color: var(--white) !important;\r\n  border-color: var(--primary-green) !important;\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='rgba(14,104,237,1)'/></svg>\") !important;\r\n}\r\n\r\n.form-check-input:checked {\r\n  background-color: var(--white) !important;\r\n}\r\n\r\n.form-check-input.is-valid {\r\n  box-shadow: none !important;\r\n  background-position: right center !important;\r\n  outline: none !important;\r\n  background-color: var(--white) !important;\r\n  border-color: var(--primary-green) !important;\r\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='rgba(5,128,141,1)'/></svg>\") !important;\r\n}\r\n\r\n.btnValidate {\r\n  position: relative;\r\n  border-radius: 6px;\r\n  background-color: var(--primary-green);\r\n  color: var(--white);\r\n  border-color: var(--primary-green);\r\n  border: none;\r\n  width: 95%;\r\n  height: 33px;\r\n  top: -5px;\r\n}\r\n\r\n.btnInfo {\r\n  background-color: var(--white-1);\r\n  color: blue;\r\n  border-color: blue;\r\n  border-radius: 500px;\r\n  display: block;\r\n  width: 15%;\r\n  height: 92%;\r\n}\r\n\r\n.btnSaveDisabled {\r\n  background-color: var(--secundary-color-disabled) !important;\r\n}\r\n\r\n.subtitle {\r\n  font-size: 13px;\r\n  color: grey;\r\n}\r\n\r\n/*  Modal Body and Head background styles */\r\n.modal-header {\r\n  background: #eee;\r\n}\r\n.modal-body {\r\n  background: linear-gradient(var(--white-1), var(--white-1), rgba(0, 0, 0, 0.1)) !important;\r\n}\r\n\r\n/*SunEditor*/\r\n.sun-editor {\r\n  font-family: 'Inter', sans-serif !important;\r\n  border: none !important;\r\n  border-radius: 1em !important;\r\n}\r\n.se-toolbar {\r\n  border-radius: 0.375rem !important;\r\n}\r\n\r\n.se-btn {\r\n  width: 30px !important;\r\n  margin: 20px !important;\r\n  /* background-color: var(--white) !important; */\r\n}\r\n.se-btn-select,\r\n.se-btn-tool-font {\r\n  width: 100px !important;\r\n}\r\n.se-btn-module-border {\r\n  border: none !important;\r\n  border-radius: 0% !important;\r\n  margin: 0.5em;\r\n  /* border-right: 0.2px solid #919191 !important; */\r\n}\r\n\r\n.sun-editor button {\r\n  color: #3d3d3d !important;\r\n}\r\n\r\n.se-toolbar {\r\n  background-color: var(--white) !important;\r\n  outline: none !important;\r\n}\r\n.sun-editor .se-btn:enabled.active {\r\n  color: var(--bs-primary) !important;\r\n}\r\n\r\n.se-wrapper-inner {\r\n  margin: 1em;\r\n}\r\n\r\n.se-resizing-bar {\r\n  background-color: var(--white) !important;\r\n  border-bottom-left-radius: 0.375rem !important;\r\n  border-bottom-right-radius: 0.375rem !important;\r\n}\r\n.se-toolbar-separator-vertical {\r\n  margin: 0.3em !important;\r\n}\r\n\r\n/* table */\r\n.sun-editor-editable td,\r\n.sun-editor-editable th {\r\n  border: 1px solid #32383e !important;\r\n}\r\n\r\n.sun-editor-editable td:hover,\r\n.sun-editor-editable th:hover {\r\n  background-color: #ececec !important;\r\n}\r\n\r\n/* ----------------- VARIABLE CLASSES ----------------- */\r\n\r\n.small {\r\n  width: 250px !important;\r\n}\r\n\r\n.medium {\r\n  width: 300px !important;\r\n}\r\n\r\n.large {\r\n  width: 350px !important;\r\n}\r\n\r\n.x-large {\r\n  width: 400px !important;\r\n}\r\n\r\n.prevent-select {\r\n  -webkit-user-select: none; /* Safari */\r\n  -ms-user-select: none; /* IE 10 and IE 11 */\r\n  user-select: none; /* Standard syntax */\r\n}\r\n\r\n/* ----------------- Width CLASSES ----------------- */\r\n.w-95 {\r\n  width: 95% !important;\r\n}\r\n\r\n.w-fit-content {\r\n  width: -moz-fit-content;\r\n  width: -webkit-fit-content;\r\n  width: fit-content !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
